// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"461344b0","27":"b7d31a7b","264":"335ecc6c","272":"bb580780","384":"0f5b03ea","422":"336eae61","577":"284e73e2","631":"e582d7e5","689":"f70ad804","711":"61571c49","787":"b9b8c727","791":"7c4fad42","926":"4ffb3139","958":"cfa99085"}[chunkId] + ".chunk.js";
};